import SaveIcon from '@mui/icons-material/Save';
import { Button, CircularProgress, InternalStandardProps } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import clx from 'classnames';
import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useEditContext } from '../../../crud-graphql-containers/ResourceEditContainer/EditContext';
import { useStyles } from './styles';

export type SaveButtonProps = {
  buttonProps?: ButtonProps;
  buttonLabel?: string;
  redirect?: boolean;
} & InternalStandardProps<React.HTMLAttributes<HTMLButtonElement>> &
  RouteComponentProps<{}>;

const SaveButton: React.FC<SaveButtonProps> = ({
  buttonProps,
  className,
  history,
  buttonLabel = 'Save',
  redirect,
  style,
}: SaveButtonProps) => {
  const classes = useStyles();
  const context = useEditContext();
  const [saving, setSaving] = useState<boolean>(false);

  const props = {
    onClick: async () => {
      if (context.onSave) {
        setSaving(true);
        await context.onSave(context.item);
        setSaving(false);
      }
      if (redirect) {
        const path: string = context.resourceConfig
          ? `/${context.resourceConfig.basePath}/list`
          : '/list';
        history.push(path);
      }
    },
    ...(buttonProps as any),
  };

  return (
    <Button
      variant="default"
      {...props}
      className={clx(classes.wrapper, className)}
      style={style}
      disabled={saving}
    >
      {saving ? <CircularProgress size={25} thickness={2} color="inherit" /> : <SaveIcon />}
      &nbsp;&nbsp;
      {buttonLabel}
    </Button>
  );
};

// eslint-disable-next-line import/no-default-export
export default SaveButton;
